import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { generateGuid, ItemBase } from '../ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { ModifierSetBase } from '../ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ModifierSetOptionBase } from '../ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { StoreCartBase } from '../ecom-base-entities/ecom-stores-base/ecom-storecartbase';
import { UserServiceBase } from '../ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { CategoryClass } from '../ecom-items/ecom-item-category/ecom-item-category.model';
import { Discount } from '../ecom-models/discount';
import { Reward } from '../ecom-models/reward';
import { EComGoogleAnalytics } from './ecom-google-analytics';
import { EcomSettingService } from './ecom-setting.service';
import { EComWebStorage } from './ecom-webstorage.services';

@Injectable({
    providedIn: 'root'
})
export class EcomCartService {

    userServiceBase: UserServiceBase;
    settings: any;
    serviceType: string;
    locationSelected: any;
    //userSelectedStore: StoreServiceBase;

    itemListAllCategory: any;

    public surcharges: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

    constructor(private webstorage: EComWebStorage,
        private eComGoogleAnalytics: EComGoogleAnalytics,
        private settingSerice: EcomSettingService
    ) {

        // this.locationSelected = this.webstorage.sessionSt_location_selected;
        // this.userServiceBase = this.webstorage.localSt_user_service_request;
        // this.settings = this.webstorage.sessionSt_settings;
    }

    setSurcharges(lst) {
        this.surcharges.next(lst);
    }

    loadService() {
        this.locationSelected = this.webstorage.sessionSt_location_selected;
        this.userServiceBase = this.settingSerice.getUserSerivce();
        this.settings = this.webstorage.sessionSt_settings;
    }

    updateCart(item: ItemBase, locationPkid, categoryList: CategoryClass[] = [], handleFreeItem = false) {
        this.loadService();
        if (!item || !this.locationSelected || !this.userServiceBase || !this.settings) return;

        item.discountedPrice = item.HasModifier ? (item.totalPrice / item.quantity) : item.priceEach;
        const taxType = this.settings.company_sell_price_tax;
        const categoryActive = categoryList.find(obj => obj.ooic_pkid == this.webstorage.sessionSt_category_selected);
        item.taxEach = this.calculateTax(taxType, item.priceEach, item.tax.tax_rate);
        this.calculateModifierPrice(item, taxType);
        this.applyReward(item, taxType);
        //this.gTagaddToCart(item, categoryActive);
        // filter the location based cart

        this.serviceType = this.settingSerice.getCompanySetting().serviceType;

        const selectedStore = this.settingSerice.getSelectedStore(this.serviceType)
        // selected from item details
        const selectedItemVariant = item.variantList.find(obj => obj.selected);
        if (selectedStore) {
            let itemVariantModifierSetOptionGuid = this.ItemVariantModifierSetOptionGuid(item);
            if (!selectedStore.storeCart) {
                selectedStore.storeCart = new StoreCartBase();
                selectedStore.storeCart.orderItems = [];

                item.variantList = [];
                item.variantList.push(selectedItemVariant);

                // first item
                //set the seletected itemvariantmodifiersetoption guid
                item.itemId = 1;
                item.ItemVariantModifierSetOptionGuid = itemVariantModifierSetOptionGuid;
                //selectedStore.storeCart.orderItemsBeforeDiscount.push({ ...item, guid: item.guid });
                item.originalItem = { ...item, guid: generateGuid() };
                this.applyDiscounts(item, taxType, handleFreeItem);
                selectedStore.storeCart.orderItems.push(item);
            } else {
                //let cartItemIndex = -1;
                //search in cart the selected item found or not
                let cartItems = selectedStore.storeCart.orderItems;
                let itemExistInCart = cartItems.find(x => (!item.HasModifier 
                    && x.itemGuid === item.itemGuid 
                    && x.itemName === item.itemName
                    && x.iuic_pkid === item.iuic_pkid)
                    || ((item.HasModifier && x.itemModId === item.itemModId && x.iuic_pkid === item.iuic_pkid)));

                itemExistInCart = cartItems.find(x => (!item.HasModifier 
                    && x.itemGuid === item.itemGuid 
                    && !x.discounted 
                    && x.itemName === item.itemName
                    && x.iuic_pkid === item.iuic_pkid && !x.hasReward) ||
                    (item.HasModifier && x.itemModId === item.itemModId && !x.discounted && x.iuic_pkid === item.iuic_pkid && !x.hasReward));

                //if (!itemExistInCart) itemExistInCart = cartItems.find(x => x.itemGuid === item.itemGuid)

                // neu da ton tai ma con co discount auto tao moi
                if (item.selectedDiscountId || !itemExistInCart) {
                    // selected from item details
                    const selectedItemVariant = item.variantList.find(obj => obj.selected);
                    item.variantList = [];
                    item.variantList.push(selectedItemVariant);
                    let itemCount = selectedStore.storeCart.orderItems.length;
                    item.itemId = itemCount + 1;
                    item.ItemVariantModifierSetOptionGuid = itemVariantModifierSetOptionGuid;
                    //selectedStore.storeCart.orderItemsBeforeDiscount.push({ ...item, guid: item.guid });
                    item.originalItem = { ...item, guid: generateGuid() };
                    this.applyDiscounts(item, taxType, handleFreeItem);
                    selectedStore.storeCart.orderItems.push(item);
                }
                else {
                    let itemCount = cartItems.length;
                    item.itemId = itemCount;
                    const itemQty = itemExistInCart.quantity;
                    let variantQty = itemExistInCart.variantList[0].variantQty;

                    itemExistInCart.variantList[0].variantQty = variantQty + item.quantity;
                    itemExistInCart.quantity = itemQty + item.quantity;
                    const itemTotalQty = itemExistInCart.quantity;
                    // if any modifier selected increase it's quantity too
                    const cartItemModifierSetList = itemExistInCart.modifierSetList;
                    for (let i = 0; i < cartItemModifierSetList.length; i++) {
                        // get only the selected modifier options
                        let cartmodifierOptions = cartItemModifierSetList[i].modifierOptions;
                        for (let j = 0; j < cartmodifierOptions.length; j++) {
                            if (cartmodifierOptions[j].optionSelected) {
                                cartmodifierOptions[j].optionQuantity = itemTotalQty;
                            }
                        }
                    }


                    itemExistInCart.specialRequest = item.specialRequest;
                    variantQty = itemExistInCart.variantList[0].variantQty;
                    const price = itemExistInCart.priceEach;
                    const priceEachAfterDiscount = itemExistInCart.priceEachAfterDiscount;
                    const priceEachBeforeDiscount = itemExistInCart.priceEachBeforeDiscount;
                    //itemExistInCart.totalPrice = variantQty * price;
                    itemExistInCart.totalPriceAfterDiscount = variantQty * priceEachAfterDiscount;
                    itemExistInCart.totalPriceBeforeDiscount = variantQty * priceEachBeforeDiscount;

                }
            }            

            const { storeCart } = selectedStore;
            storeCart.orderSubTotal = Number(storeCart.orderSubTotal) + Number(item.totalPrice);
            //storeCart.orderDiscountTotal = Number(storeCart.orderDiscountTotal) + Number(item.totalDiscountAmount);
            // storeCart.orderDiscountTotalOADP = Number(storeCart.orderDiscountTotalOADP) + OADPOrderDiscountTotal;
            storeCart.orderTax = Number(storeCart.orderTax) + Number(item.totalTax);
            storeCart.orderTax = Number(storeCart.orderTax.toFixed(2));
            storeCart.orderTotal = Number(storeCart.orderSubTotal) + Number(storeCart.orderTax);
            this.webstorage.sessionSt_cart_item = null;
        }

        this.webstorage.localSt_shopping_cart = selectedStore;
        this.userServiceBase.serviceCartStarteddAt = new Date();
        //this.webstorage.localSt_user_service_request = this.userServiceBase;
        this.settingSerice.setUserSerivce(this.userServiceBase);
        this.webstorage.sessionSt_item_list = this.itemListAllCategory;

        if (item.buyGetItems && item.buyGetItems.length) {
            item.buyGetItems.forEach(getItem => {
                getItem.parentGuid = item.guid;
                getItem.discounted = true;
                getItem.isFree = true;
                getItem.selectedDiscountId = item.selectedDiscountId;
                getItem.priceEach = 0;
                this.updateCart(getItem, locationPkid, categoryList, true)
            });
        }

        if (item.combinationBuyItems.length) {
            item.isBuyItem = true;
            item.combinationBuyItems.forEach(getItem => {
                getItem.parentGuid = item.guid;
                getItem.discounted = true;
                //getItem.isFree = true;
                getItem.selectedDiscountId = item.selectedDiscountId;
                //getItem.priceEach = 0;
                getItem.canRemove = false;
                this.updateCart(getItem, locationPkid, categoryList, false)
            });

        }

        if (item.combinationGetItems.length) {
            item.combinationGetItems.forEach(getItem => {
                getItem.parentGuid = item.guid;
                getItem.discounted = true;
                //getItem.isFree = true;
                getItem.selectedDiscountId = item.selectedDiscountId;
                //getItem.priceEach = 0;
                getItem.canRemove = false;
                this.updateCart(getItem, locationPkid, categoryList, true)
            });

        }

        // NONE
        if (item.itemsDiscounted.length) {
            item.itemsDiscounted.forEach(dItem => {
                dItem.selectedDiscountId = 0;
                if (dItem.discounted) {
                    dItem.discounted = true;
                    dItem.selectedDiscountId = item.selectedDiscountId;
                }
                this.updateCart(dItem, locationPkid, categoryList, false)
            });

        }

        if (item.combinationBuyItems.length || item.combinationGetItems.length) {
            const discounts = this.settingSerice.getDiscounts();
            const selectedDiscount = discounts.find(x => x.discount_pkid === item.selectedDiscountId) as Discount;
            if (selectedDiscount) {
                selectedDiscount.applications[selectedDiscount.discount_pkid] = selectedDiscount.applications[selectedDiscount.discount_pkid] || 0;
                selectedDiscount.applications[selectedDiscount.discount_pkid]++;
            }
        }
    }
    applyReward(item: ItemBase, taxType: string, handleBuyGet = false) {
        if (!item.hasReward) return;

        debugger
        if (item.reward.type === "FREE_PRODUCT" || item.reward.value_type === "FREE") {
            item.discountedPrice = item.totalModifersPrice;
            item.discountAmount = item.priceEach;
            item.taxEach = 0;
        }
    }

    refreshCartItem(itemId: number, locationId, reward: Reward) {
        this.loadService();
        this.serviceType = this.settingSerice.getCompanySetting().serviceType;

        const taxType = this.settings.company_sell_price_tax;
        const selectedStore = this.settingSerice.getSelectedStore(this.serviceType)
        const cartItems = selectedStore.storeCart.orderItems;

        const index = cartItems.findIndex(x => +x.itemGuid === itemId
            && !x.hasReward && !x.discounted
        );

        if (index !== -1) {
            const { discountedItem, nonDiscountedItem } = this.splitItemByReward(cartItems[index]);

            if (discountedItem) {
                discountedItem.hasReward = true;
                discountedItem.reward = reward;

                //if()

                if (discountedItem.reward.type === "FREE_PRODUCT" || discountedItem.reward.value_type === "FREE") {
                    discountedItem.discountedPrice = discountedItem.totalModifersPrice;
                    discountedItem.discountAmount = discountedItem.priceEach;
                    discountedItem.taxEach = 0;
                } else {
                    const price = this.calculatePrice(discountedItem.priceEach,
                        discountedItem.tax.tax_rate,
                        reward.reward_value,
                        taxType,
                        reward.value_type === "DISCOUNT" ? "PERCENTAGE" : reward.value_type,
                        reward.value_type === "PERCENTAGE" ? reward.max_value : 0);

                    discountedItem.discountAmount = price.discountAmount;
                    discountedItem.discountedPrice = price.priceAfterDiscount;
                    discountedItem.taxEach = price.taxAmount;
                    discountedItem.priceEachBeforeTax = price.finalPrice;
                    this.calculateModifierPrice(discountedItem, taxType);
                }


                cartItems[index] = discountedItem;
            }
            if (nonDiscountedItem) {
                nonDiscountedItem.totalPrice = cartItems[index].HasModifier ? (cartItems[index].totalPrice / (nonDiscountedItem.quantity + 1)) : cartItems[index].priceEach;
                this.updateCart(nonDiscountedItem, locationId);
            }
        }
        this.settingSerice.setUserSerivce(this.userServiceBase);
    }

    splitItemByReward(item) {
        const discountedQty = 1;
        const nonDiscountedQty = item.quantity - discountedQty;

        let discountedItem: ItemBase;
        let nonDiscountedItem: ItemBase;

        if (discountedQty > 0) {
            discountedItem = {
                ...item,
                iuic_pkid: 0,
                quantity: 1,
                guid: generateGuid(),
                modifierSetList: item.modifierSetList.map(modifierSet => ({
                    ...modifierSet,
                    modifierGuid: generateGuid(),
                    modifierOptions: modifierSet.modifierOptions.map(modifierOption => ({
                        ...modifierOption,
                        optionGuid: generateGuid()
                    }))
                }))
            };
        }

        if (nonDiscountedQty > 0) {
            nonDiscountedItem = {
                ...item,
                iuic_pkid: 0,
                quantity: nonDiscountedQty,
                guid: generateGuid(),
                modifierSetList: item.modifierSetList.map(modifierSet => ({
                    ...modifierSet,
                    modifierGuid: generateGuid(),
                    modifierOptions: modifierSet.modifierOptions.map(modifierOption => ({
                        ...modifierOption,
                        optionGuid: generateGuid()
                    }))
                }))
            };
        }

        return { discountedItem, nonDiscountedItem };
    }
    calculatePrice(
        price,
        taxRatePercent,
        discountRatePercentOrAmount,
        taxType: string,
        discountType: string,
        maxDiscountAmount = 0,
    ) {
        //taxType = "TAX_IN";
        // Chuyển đổi từ phần trăm sang thập phân
        let taxRate = taxRatePercent / 100;

        let priceAfterDiscount, discountAmount, taxAmount, finalPrice, priceBeforeTax;

        if (taxType === "TAX_IN") {
            // Nếu giá đã bao gồm thuế
            // Tính giá trước thuế
            priceBeforeTax = price / (1 + taxRate);

            if (discountType === "AMOUNT") {
                // Nếu giảm giá là một số tiền cụ thể
                discountAmount = discountRatePercentOrAmount;

                if (maxDiscountAmount) {
                    discountAmount = Math.min(discountAmount, maxDiscountAmount);
                }

                const taxFactor = discountRatePercentOrAmount / price;
                priceAfterDiscount = priceBeforeTax * (1 - taxFactor);
                const originalTaxAmount = priceBeforeTax * taxRate;
                taxAmount = originalTaxAmount * (1 - taxFactor);
                finalPrice = price - discountAmount;
                return {
                    priceAfterDiscount,
                    discountAmount,
                    taxAmount,
                    finalPrice,
                    price,
                    priceBeforeTax
                };
            } if (discountType === "PERCENTAGE") {
                // Nếu giảm giá là tỷ lệ phần trăm
                const discountRate = discountRatePercentOrAmount / 100;
                discountAmount = price * discountRate;
                if (maxDiscountAmount) {
                    discountAmount = Math.min(discountAmount, maxDiscountAmount);
                }

                priceAfterDiscount = price - discountAmount;
                taxAmount = (priceAfterDiscount / (1 + taxRate)) * taxRate;
                return {
                    priceAfterDiscount,
                    discountAmount,
                    taxAmount,
                    finalPrice,
                    price,
                    priceBeforeTax
                };
            }
            if (discountType === "FIXED_AMOUNT") {
                discountRatePercentOrAmount = price - discountRatePercentOrAmount;
                discountAmount = discountRatePercentOrAmount;

                if (maxDiscountAmount) {
                    discountAmount = Math.min(discountAmount, maxDiscountAmount);
                }
                const taxFactor = discountRatePercentOrAmount / price;
                priceAfterDiscount = priceBeforeTax * (1 - taxFactor);
                const originalTaxAmount = priceBeforeTax * taxRate;
                taxAmount = originalTaxAmount * (1 - taxFactor);
                finalPrice = price - discountAmount;
                return {
                    priceAfterDiscount,
                    discountAmount,
                    taxAmount,
                    finalPrice,
                    price,
                    priceBeforeTax
                };
            }

            // Tính giá sau giảm giá nhưng trước thuế
            priceAfterDiscount = price - discountAmount;

            // Tính số thuế trên giá đã giảm
            taxAmount = priceAfterDiscount * taxRate;

            // Tính tổng số tiền phải trả
            finalPrice = priceAfterDiscount + taxAmount;

            // Recalute discountAmount
            //discountAmount = price * discountRate;

        } else {
            // Nếu giá chưa bao gồm thuế
            if (discountType === "AMOUNT") {
                // Nếu giảm giá là một số tiền cụ thể
                discountAmount = discountRatePercentOrAmount;
            } if (discountType === "PERCENTAGE") {
                // Nếu giảm giá là tỷ lệ phần trăm
                const discountRate = discountRatePercentOrAmount / 100;
                discountAmount = price * discountRate;
            }
            if (discountType === "FIXED_AMOUNT") {
                discountAmount = price - discountRatePercentOrAmount;
            }

            if (maxDiscountAmount) {
                discountAmount = Math.min(discountAmount, maxDiscountAmount);
            }

            // Tính giá sau giảm giá
            priceAfterDiscount = price - discountAmount;

            // Tính số thuế trên giá đã giảm
            taxAmount = priceAfterDiscount * taxRate;

            // Tính tổng số tiền phải trả
            finalPrice = priceAfterDiscount + taxAmount;
        }

        return {
            priceAfterDiscount,
            discountAmount,
            taxAmount,
            finalPrice,
            price,
            priceBeforeTax
        };
    }

    calculateModifierPrice(item: ItemBase, taxType: string) {
        item.totalPrice = item.quantity * item.priceEach;
        if (item.HasModifier) {
            item.modifierSetList.filter(x => x.modifierSetSelected).forEach((modifier: ModifierSetBase) => {

                modifier.modifierOptions.filter(x => x.optionSelected).forEach((option: ModifierSetOptionBase) => {
                    //if (!option.optionSelected) return;

                    item.totalPrice += item.quantity * option.optionPrice;
                    item.totalModifersPrice += option.optionPrice;
                    const taxEach = this.calculateTax(taxType, option.optionPrice, option.optionTaxRate);
                    option.optionTaxAmt = taxEach;
                    //modTax += taxEach;

                    option.modifiers_into_modifier.filter(x => x.optionSelected).forEach((modInMod: ModifierSetOptionBase) => {
                        //if (!option.optionSelected) return;

                        item.totalPrice += modInMod.optionPrice;
                        item.totalModifersPrice += modInMod.optionPrice;
                        const taxEach = this.calculateTax(taxType, modInMod.optionPrice, modInMod.optionTaxRate);
                        modInMod.optionTaxAmt = taxEach;
                        // modTax += taxEach;

                    });

                });
            });
        }
    }



    applyDiscounts(item: ItemBase, taxType: string, handleBuyGet = false) {
        this.applyDiscounts2(item, taxType, handleBuyGet);        
    }

    applyDiscounts2(item: ItemBase, taxType: string, handleGetItem = false) {

        //console.log("item", item);
        let allowUpdateExistItem = true;
        const discounts = this.settingSerice.getDiscounts();
        //const ids = [159, 160, 161, 162, 163, 164, 165, 166];
        //console.log(discounts.filter(x => ids.includes(x.discount_pkid)));
        const selectedDiscount = discounts.find(x => x.discount_pkid === item.selectedDiscountId) as Discount;
        if (!selectedDiscount) return allowUpdateExistItem;

        let discountType = selectedDiscount.discount_value_type;

        if (handleGetItem) {

            const minQuantity = selectedDiscount.discount_buy_quantity;
            const maxUsesPerOrder = selectedDiscount.discount_max_uses_per_order;
            selectedDiscount.applications[selectedDiscount.discount_pkid] = selectedDiscount.applications[selectedDiscount.discount_pkid] || 0;
            const max = selectedDiscount.applications[selectedDiscount.discount_pkid];
            if (max != maxUsesPerOrder) {

                item.discounted = true;
                item.discountName = selectedDiscount.discount_name;
                //selectedDiscount.applications[item.itemGuid]++;
                if (selectedDiscount.discount_value_type === "FREE") {
                    discountType = "FIXED_AMOUNT";
                    //item.priceEach = 0;
                    // The item is free of charge, but the modder is not offering it for free
                    item.discountedPrice = item.totalModifersPrice;
                    item.discountAmount = item.priceEach;
                    item.taxEach = 0;
                    return;
                }
                if (selectedDiscount.discount_primary_type === "FIXED_AMOUNT" || selectedDiscount.discount_value_type === "FIXED") {
                    discountType = "FIXED_AMOUNT";
                }
                const price = this.calculatePrice(item.priceEach,
                    item.tax.tax_rate,
                    selectedDiscount.discount_value,
                    taxType,
                    discountType);
                // const price2 = this.calculatePrice(item.priceEach,
                //     item.tax.tax_rate,
                //     selectedDiscount.discount_value,
                //     "TAX_IN",
                //     discountType);
                item.discountAmount = price.discountAmount;
                item.discountedPrice = price.priceAfterDiscount;
                item.taxEach = price.taxAmount;
                item.priceEachBeforeTax = price.finalPrice;
                this.calculateModifierPrice(item, taxType);
                console.log("QUANTITY", price);
            }
        }


        if (selectedDiscount.discount_primary_type === "BUY_GET") {

            item.discounted = true;
            //item.isFree = true;
            item.discountName = selectedDiscount.discount_name;
            item.discountedPrice = item.priceEach - item.discountAmount;
            return allowUpdateExistItem;
        }

        const maxUsesPerOrder = selectedDiscount.discount_max_uses_per_order;
        selectedDiscount.applications[selectedDiscount.discount_pkid] = selectedDiscount.applications[selectedDiscount.discount_pkid] || 0;
        const max = selectedDiscount.applications[selectedDiscount.discount_pkid];

        //let discountType = selectedDiscount.discount_value_type;

        if (selectedDiscount.discount_minimum_requirement === "QUANTITY") {
            let minQuantity = selectedDiscount.discount_minimum_requirement_quantity;
            let quantity = item.quantity;
            if (item.combinationGetItems) {
                quantity = quantity + item.combinationGetItems.reduce((sum, item) => sum + item.quantity, 0);
            }
            if (quantity >= minQuantity && (maxUsesPerOrder === null || max != maxUsesPerOrder)) {

                item.discounted = true;
                item.discountName = selectedDiscount.discount_name;
                if (!item.combinationGetItems.length)
                    selectedDiscount.applications[selectedDiscount.discount_pkid]++;
                if (selectedDiscount.discount_primary_type === "FIXED_AMOUNT") {
                    discountType = "FIXED_AMOUNT";
                }
                const price = this.calculatePrice(item.priceEach,
                    item.tax.tax_rate,
                    selectedDiscount.discount_value,
                    taxType,
                    discountType);
                // const price2 = this.calculatePrice(item.priceEach,
                //     item.tax.tax_rate,
                //     selectedDiscount.discount_value,
                //     "TAX_IN",
                //     discountType);
                const priceAfterDiscount = price.price - price.finalPrice;
                // Fixed amount need to check later (ex: buy 2 item get 10RM off)
                item.discountAmount = price.discountAmount; // Will recalcultate in cart
                //item.discountedPrice = item.quantity * priceAfterDiscount;
                item.taxEach = price.taxAmount;
                this.calculateModifierPrice(item, taxType);
                //item.discountedPrice = item.totalPrice - item.discountAmount;
                item.discountedPrice = item.priceEach - item.discountAmount;
                console.log("QUANTITY", price);
            }
            else {
                item.autoDiscountPrice = 0;
                item.fullPriceItems = item.quantity;
                item.discountedItems = 0;
            }

        }
        if (selectedDiscount.discount_minimum_requirement === "AMOUNT") {
            const totalAmount = item.quantity * item.priceEach;
            const minAmount = selectedDiscount.discount_minimum_requirement_amount;

            if (totalAmount >= minAmount && (maxUsesPerOrder === null || max != maxUsesPerOrder)) {
                //const itemsPerDiscount = Math.floor(totalAmount / item.priceEach);
                item.discounted = true;
                item.discountName = selectedDiscount.discount_name;
                selectedDiscount.applications[selectedDiscount.discount_pkid]++;
                if (selectedDiscount.discount_primary_type === "FIXED_AMOUNT") {
                    discountType = "FIXED_AMOUNT";
                }
                const price = this.calculatePrice(item.priceEach,
                    item.tax.tax_rate,
                    selectedDiscount.discount_value,
                    taxType,
                    discountType);
                item.discountAmount = price.discountAmount;
                item.discountedPrice = item.totalPrice - item.discountAmount;
                item.taxEach = price.taxAmount;
                this.calculateModifierPrice(item, taxType);
                console.log("AMOUNT", price);
            }

            item.fullPriceItems = item.quantity - item.discountedItems;
        }
        if (selectedDiscount.discount_minimum_requirement === "NONE") {
            if (maxUsesPerOrder === null || max != maxUsesPerOrder) {

                item.discounted = true;
                item.discountName = selectedDiscount.discount_name;
                selectedDiscount.applications[selectedDiscount.discount_pkid]++;
                const price = this.calculatePrice(item.priceEach,
                    item.tax.tax_rate,
                    selectedDiscount.discount_value,
                    taxType,
                    selectedDiscount.discount_value_type);
                item.discountAmount = price.discountAmount;
                item.discountedPrice = price.priceAfterDiscount;
                item.taxEach = price.taxAmount;
                this.calculateModifierPrice(item, taxType);
                console.log("NONE", price)
            }
            else {
                item.autoDiscountPrice = 0;
                item.fullPriceItems = item.quantity;
                item.discountedItems = 0;
            }
        }


        //const discountedTotal = item.discountedItems * item.autoDiscountPrice;
        //const fullPriceTotal = item.fullPriceItems * item.priceEach;

        //item.totalPrice = discountedTotal + fullPriceTotal;

        //this.webstorage.sessionSt_discounts = [];
        //this.webstorage.sessionSt_discounts = discounts;

        this.settingSerice.setDiscounts(discounts);

        return allowUpdateExistItem;
    }

    splitCartItemByDiscount(item, maxDiscountUses, discount: Discount) {
        const discountedQty = Math.min(item.quantity, maxDiscountUses);
        const nonDiscountedQty = item.quantity - discountedQty;

        let discountedItems: ItemBase[] = [];
        let nonDiscountedItem: ItemBase;

        if (discountedQty > 0) {
            for (let i = 0; i < discountedQty; i++) {
                discountedItems.push({
                    ...item,
                    quantity: 1,
                    guid: generateGuid(),
                    selectedDiscountId: discount,
                    modifierSetList: item.modifierSetList.map(modifierSet => ({
                        ...modifierSet,
                        modifierGuid: generateGuid(),
                        modifierOptions: modifierSet.modifierOptions.map(modifierOption => ({
                            ...modifierOption,
                            optionGuid: generateGuid()
                        }))
                    }))
                });
            }
        }

        if (nonDiscountedQty > 0) {
            nonDiscountedItem = {
                ...item,
                quantity: nonDiscountedQty,
                guid: generateGuid(),
                modifierSetList: item.modifierSetList.map(modifierSet => ({
                    ...modifierSet,
                    modifierGuid: generateGuid(),
                    modifierOptions: modifierSet.modifierOptions.map(modifierOption => ({
                        ...modifierOption,
                        optionGuid: generateGuid()
                    }))
                }))
            };
        }

        return { discountedItems, nonDiscountedItem };
    }

    discounts(arg0: string, discounts: any) {
        throw new Error('Method not implemented.');
    }

    ItemVariantModifierSetOptionGuid(item: ItemBase) {
        let itemGuid = item.itemGuid;
        // selected from item details
        const selectedItemVariant = item.variantList.find((obj) => {
            return obj.selected === true;
        });
        let variantGuid = selectedItemVariant ? selectedItemVariant.variantGuid : "xx";
        //selected modifier options
        let selectedModifiersetOptions = '';
        for (let i = 0; i < item.modifierSetList.length; i++) {
            const modifierOptionSelected = item.modifierSetList[i].modifierOptions.filter(m => m.optionSelected === true);
            if (modifierOptionSelected.length > 0) {
                selectedModifiersetOptions = selectedModifiersetOptions + item.modifierSetList[i].modifierGuid + ",";
                modifierOptionSelected.forEach(element => {
                    selectedModifiersetOptions = selectedModifiersetOptions + element.optionGuid + ",";
                });
            }
        }
        return itemGuid + "," + variantGuid + "," + selectedModifiersetOptions;
    }

    /**
     * Calculate the tax amount based on the type of tax and given price and rate.
     * @param {string} type - The type of tax calculation ('TAX_IN' or any other type).
     * @param {number} price - The price amount.
     * @param {number} taxRate - The tax rate as a percentage.
     * @returns {number} - The calculated tax amount rounded to 4 decimal places.
    **/
    calculateTax(type: string, price: number, taxRate: number) {
        let taxAmount = 0;
        if (type === 'TAX_IN') {

            const actualPrice = price / (1 + taxRate / 100);
            taxAmount = price - actualPrice;
        } else {
            taxAmount = (taxRate / 100) * price;
        }
        return Number(taxAmount.toFixed(4));
    }
}
